import React from 'react'
import { SiMicrosoftexcel } from 'react-icons/si'

/**
 * Indicación destacada sobre los gráficos clicables (RG-602): chip verde (color de Excel) con el ícono,
 * para que el usuario note que las barras / porciones descargan sus casos.
 */
const AyudaExportar = ({ texto }) => (
    <div className='d-flex justify-content-center mb-2'>
        <span
            style={{
                display: 'inline-flex',
                alignItems: 'center',
                gap: 6,
                background: '#e6f4ea',
                border: '1px solid #1D6F42',
                borderRadius: 999,
                color: '#1D6F42',
                fontSize: '0.8rem',
                fontWeight: 600,
                padding: '3px 14px'
            }}
        >
            <SiMicrosoftexcel size={14} />
            {texto}
        </span>
    </div>
)

export default AyudaExportar
